import React, { useState } from "react";
import {
    Card,
    CardBody,
    Button,
    Input,
    Label,
    Container,
    Row,
    Col,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../utils/api";

const SUPERADMIN_MOBILE = "9810921977";

const SuperadminLogin = () => {

    const navigate = useNavigate();

    const [mobile, setMobile] =
        useState(SUPERADMIN_MOBILE);
    const [otp, setOtp] =
        useState("");
    const [otpSent, setOtpSent] =
        useState(false);
    const sendOTP = async () => {
        try {
            await api.post(
                "/superadmin/send-otp",
                {
                    mobile
                }
            );
            setOtpSent(true);
            toast.success(
                "OTP sent successfully"
            );

        }
        catch (err) {

            toast.error(
                err.response?.data?.message ||
                "OTP failed"
            );
        }
    };

    const verifyOTP =
        async () => {

            try {
                const res =
                    await api.post(
                        "/superadmin/verify-otp",
                        {
                            mobile,
                            otp
                        }
                    );

                localStorage.setItem(
                    "superadmin_token",
                    res.data.token
                );

                localStorage.setItem(
                    "superadmin_user",
                    JSON.stringify(
                        res.data.user
                    )
                );

                toast.success(
                    "Login successful"
                );
                navigate("/clients");

            }
            catch (err) {

                toast.error(
                    err.response?.data?.message ||
                    "Invalid OTP"
                );

            }
        };

    return (

        <Container fluid>

            <Row
                className="justify-content-center align-items-center"
                style={{
                    minHeight: "100vh"
                }}
            >

                <Col
                    md="4"
                >

                    <Card
                        className="shadow rounded-4"
                    >

                        <CardBody
                            className="p-4"
                        >


                            <h3 className="text-center mb-4">
                                Super Admin Login
                            </h3>


                            <Label>
                                Mobile Number
                            </Label>


                            <Input
                                value={mobile}
                                disabled
                                className="mb-3"
                            />



                            {
                                !otpSent ?


                                    <Button
                                        color="primary"
                                        block
                                        onClick={sendOTP}
                                    >

                                        Send OTP

                                    </Button>


                                    :

                                    <>


                                        <Label className="mt-3">
                                            Enter OTP
                                        </Label>


                                        <Input
                                            value={otp}
                                            onChange={(e) =>
                                                setOtp(e.target.value)
                                            }
                                            placeholder="Enter OTP"
                                        />


                                        <Button
                                            color="success"
                                            block
                                            className="mt-3"
                                            onClick={verifyOTP}
                                        >

                                            Verify OTP

                                        </Button>


                                    </>


                            }


                        </CardBody>

                    </Card>


                </Col>

            </Row>


        </Container>

    );

};


export default SuperadminLogin;